import * as React from "react";
import {Fragment} from "react";
import {cx} from "emotion";

import "./bubble-noti.scss";

import {cs}                     from "../../react/chain-services";
import {stateChangeNestedValue} from "../../react/state-change-nested-value";
import {TimedAction}            from "../../react/timed-action";
import {UseState}               from "../../react/use-state";
import {Link}                   from "../../react/cst2";

export const BubbleNoti = ({next}:{
    next    : Link<React.ReactNode, {
        show    : (props:{
            message     : string,
            color       : string,
            duration    : number,
        }) => void,
    }>,
}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => <Fragment>
        {next({
            show: ({message, color, duration=2000}) => state.onChange({
                time: Date.now(),
                message,
                color,
                duration,
            }),
        })}

        {state.value && cs(
            ["animation", (_, next) => UseState({next})],
            ({animation}) => <Fragment>
                <div className="bubble-noti-3e8" xd-qa-type="modal" xd-qa-name="Notification">
                    <div className={cx("message", animation.value, state.value.color)} xd-qa-type="label" xd-qa-name="Content">
                        {state.value.message}

                        <div className="close" onClick={() => stateChangeNestedValue(state, ["time"], () => Date.now() - state.value.duration)}>
                            &times;
                        </div>
                    </div>

                </div>


                <TimedAction {...{
                    time: state.value.time + 10,
                    action: () => animation.onChange("show"),
                }}/>
                <TimedAction {...{
                    time: state.value.time + state.value.duration,
                    action: () => animation.onChange("hide"),
                }}/>
                <TimedAction {...{
                    time: state.value.time + state.value.duration + 300,
                    action: () => state.onChange(null),
                }}/>
            </Fragment>,
        )}
    </Fragment>,
);